/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/widgets/mailingLists/model/mailingListModel'], function(backbone, MailingListModel) {
    return backbone.Model.extend(
        {
            defaults: {
                /**
                 * @var backbone.Collection of MailingListModel
                 */
                lists: new backbone.Collection(),
                /**
                 * @var null|MailingListModel
                 */
                currentList: new MailingListModel(),
                listTokenChosen: null,

                user: null,
                cartToken: null,
                cartItemId: null,

                unSavedChanges: false,
                allItemsSelected: false,
                listLoading: true,
                uploadListLoading: false
            }
        },
        {
            MIN_LIST_ITEMS_LENGTH: 20
        }
    );
});
